import { Container } from 'components/container'
import { useDataContext } from 'context/data-context'
import { Article } from './components/article'
import { DownloadButtons } from './components/download-buttons'
import { Form } from './components/form'
import { Logo } from './components/logo'
import { Social } from './components/social'
import { Video } from './components/video'
import { Intro, Outro, Section, SectionTitle } from './styled'

export const Home = () => {
  const { strings, articles } = useDataContext()

  return (
    <>
      <Logo />
      <Container>
        <Intro>{strings.intro}</Intro>
        <DownloadButtons />

        <Video />

        <Section>
          <SectionTitle>
            Только <br />
            на Votvot
          </SectionTitle>

          {articles
            .filter((a) => a.section === 'Exclusively')
            .map((a) => (
              <Article key={a.id} {...a} />
            ))}
        </Section>

        <Section>
          <SectionTitle>
            Скоро
            <br />
            на Votvot
          </SectionTitle>

          {articles
            .filter((a) => a.section === 'Coming soon')
            .map((a) => (
              <Article key={a.id} {...a} isWide />
            ))}
        </Section>

        <Outro>
          <p>{strings.download_text}</p>
          <DownloadButtons />
        </Outro>

        <Form />
        <Social />
        <Logo />
      </Container>
    </>
  )
}
